/** Radice dell'API per i componenti di @sepma/calendar (aggiungono `/calendars`, `/bookings`, `/booking-types`, `/booking`). */
export const CALENDAR_API = '/api'
